module.exports = __webpack_public_path__ + "img/116-e4af04.png";